var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9025 21.9202L13.4509 18.9921C13.1737 18.8091 12.8965 18.8091 12.6193 18.9921L7.26009 21.8287C6.61329 22.1947 5.87408 21.6457 5.96648 20.9137L6.98288 14.966C7.07528 14.6915 6.98288 14.417 6.70568 14.234L2.27047 9.84193C1.71607 9.29292 2.08567 8.46943 2.73247 8.37793L9.01569 7.55439C9.29289 7.55439 9.57008 7.2799 9.66248 7.0054L12.0649 1.51527C12.3421 0.874756 13.3585 0.783254 13.6357 1.51527L16.3153 7.0054C16.4077 7.2799 16.6849 7.46291 16.9621 7.46291L23.2453 8.28642C23.9845 8.37792 24.2617 9.29294 23.7073 9.75045L19.2721 14.1425C19.0873 14.3255 18.9949 14.6 18.9949 14.8745L19.8265 20.9137C20.2885 21.7372 19.5493 22.1947 18.9025 21.9202Z",
    fill: "#006CFA",
    stroke: "#006CFA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.21c245b02634d39a2b1130ee9daa5f15.svg";
export { ForwardRef as ReactComponent };